// DRAGGABLE ANCHOR TAG ITEMS SLIDER

function handleSlider(target) {
  const handleSlider = target;
  let isDown = false;
  let startX;
  let scrollLeft;

  if (!handleSlider) return;

  handleSlider.addEventListener("pointerdown", (e) => {
    isDown = true;
    handleSlider.classList.add("active");
    startX = e.pageX - handleSlider.offsetLeft;
    scrollLeft = handleSlider.scrollLeft;
  });

  handleSlider.addEventListener("pointerleave", () => {
    isDown = false;
    handleSlider.classList.remove("active");
    handleSlider.classList.remove("move");
  });

  handleSlider.addEventListener("pointerup", (e) => {
    if (handleSlider.classList.contains("move")) {
      console.log("move");
      e.preventDefault();
    }
    isDown = false;
    handleSlider.classList.remove("active");
    handleSlider.classList.remove("move");
  });

  handleSlider.addEventListener("pointermove", (e) => {
    if (!isDown) return;
    e.preventDefault();
    if (handleSlider.classList.contains("active")) {
      handleSlider.classList.add("move");
    }
    const x = e.pageX - handleSlider.offsetLeft;
    const walk = (x - startX) * 1.5; // Adjust scrolling speed
    handleSlider.scrollLeft = scrollLeft - walk;
  });
}
